window.UK_G6_MANUAL_DATA = {
  "manual": {
    "title": "G6 Wi-Fi Gateway manual",
    "hero_title": "G6 Wi-Fi Gateway",
    "product_family": "G6 Wi-Fi Gateway",
    "primary_app": "TTLock",
    "manual_version": "V26.1",
    "lead": "Set up your G6 in TTLock, read its status light and remove it from the app.",
    "app_links": {
      "android_google_play": "https://play.google.com/store/apps/details?id=com.tongtongsuo.app",
      "ios_app_store": "https://apps.apple.com/app/ttlock/id1033046018"
    },
    "checklist": [
      "Connect the G6 to its power supply.",
      "Open TTLock and have your 2.4 GHz Wi-Fi name and password ready.",
      "Check for alternating red and blue before adding the gateway."
    ],
    "quick_specs": {
      "App": "TTLock",
      "Wi-Fi": "2.4 GHz only"
    },
    "search_placeholder": "Search steps, settings or a problem"
  },
  "guides": [
    {
      "handle": "g6-01",
      "title": "Indicator light status",
      "category": "Preparation",
      "steps": [
        "Connect the G6 gateway to its power supply.",
        "Observe the indicator colour and flashing pattern.",
        "Compare the pattern with the status descriptions below."
      ],
      "notes": [
        "Red and blue flashing alternately: ready to be added in TTLock.",
        "Blue flashing: TTLock binding is being configured.",
        "Blue stays on: Matter ready state; the gateway can be added by a Matter controller.",
        "Red flashing: poor network; the gateway cannot communicate with the server."
      ],
      "warnings": [],
      "common_mistakes": [
        "Confusing flashing blue (TTLock configuration) with steady blue (Matter ready state)."
      ],
      "summary": "Understand the meaning of different LED indicator light patterns on the G6 Smart Gateway.",
      "expected_result": "You can correctly identify whether the gateway is in ready state, has poor network connection, or is in normal working status based on the LED indicator behavior.",
      "images": [
        {
          "src": "uk-manual-g6-01-1.webp",
          "alt": "G6 indicators: alternating red/blue is ready for TTLock; flashing blue is configuration; steady blue is Matter ready; flashing red is poor network."
        }
      ]
    },
    {
      "handle": "g6-02",
      "title": "Bind the gateway to the app",
      "category": "App setup",
      "steps": [
        "Connect the gateway to its power supply.",
        "Open the \"TTLock\" APP on your smartphone.",
        "Tap the “+” button in the upper-right corner of the TTLock home screen.",
        "Select \"G6 (Matter)\" from the device list.",
        "Verify the gateway indicator is flashing red and blue alternately, then tap \"Next\".",
        "When the G6 device appears in the search results, tap the \"+\" button next to it.",
        "Tap “WiFi Name” and select an available 2.4 GHz Wi-Fi network.",
        "Enter your WiFi password accurately.",
        "Enter a recognizable name for your Gateway (e.g., \"Living Room Gateway\").",
        "Tap \"OK\" to complete the binding process.",
        "Wait for the gateway to automatically search for and connect to devices already bound in the APP."
      ],
      "notes": [
        "The G6 uses 2.4 GHz Wi-Fi only.",
        "The images show example network and device details; enter your own details."
      ],
      "warnings": [],
      "common_mistakes": [
        "Choosing a 5 GHz network; G6 requires 2.4 GHz.",
        "Entering the wrong Wi-Fi password."
      ],
      "summary": "Connect the G6 Smart Gateway to the TTLock APP and configure it for use with your WiFi network.",
      "expected_result": "The gateway searches for devices already bound in TTLock and displays connected devices.",
      "images": [
        {
          "src": "uk-manual-g6-bind-01_2x.jpg",
          "alt": "TTLock home screen: tap + in the upper-right corner."
        },
        {
          "src": "uk-manual-g6-bind-02_2x.jpg",
          "alt": "Add devices: select G6 (Matter)."
        },
        {
          "src": "uk-manual-g6-bind-03_2x.jpg",
          "alt": "Add Gateway: tap Next when the indicator flashes red and blue alternately."
        },
        {
          "src": "uk-manual-g6-bind-04_2x.jpg",
          "alt": "Choose Gateway: tap + next to the discovered G6."
        },
        {
          "src": "uk-manual-g6-bind-05_2x.jpg",
          "alt": "Configure Network: select a 2.4 GHz Wi-Fi network, then enter its password and a gateway name."
        },
        {
          "src": "uk-manual-g6-bind-06_2x.jpg",
          "alt": "Configure Network: tap OK after entering your network details."
        },
        {
          "src": "uk-manual-g6-bind-07_2x.jpg",
          "alt": "G6 displays devices connected to this gateway."
        }
      ]
    },
    {
      "handle": "g6-03",
      "title": "Set up Matter",
      "category": "Matter setup",
      "summary": "Associate a lock in TTLock, then add your G6 to Google Home or Apple Home using the gateway’s own Matter code.",
      "steps": [
        "Open the G6 gateway page in TTLock, then tap “Matter”.",
        "Tap “Associate a lock” and select the device you want to connect to Matter.",
        "Tap “Save”.",
        "Tap “Pair with a Matter App”, then tap “Start”.",
        "Open Google Home or Apple Home and tap “+” or “Add Accessory”.",
        "Scan the Matter QR code on the bottom of your own gateway and complete the app’s binding steps."
      ],
      "notes": [
        "The supplier instructions illustrate Google Home and Apple Home.",
        "QR codes and network/device details shown in the manual are examples. Use the code on your own gateway."
      ],
      "warnings": [],
      "common_mistakes": [
        "Skipping the lock association or Save step.",
        "Scanning the example QR code in the manual instead of the code on your gateway."
      ],
      "expected_result": "The selected lock is associated in TTLock and the gateway is added in your chosen Home app.",
      "images": [
        {
          "src": "uk-manual-g6-matter-01_2x.jpg",
          "alt": "G6 gateway: tap Matter."
        },
        {
          "src": "uk-manual-g6-matter-02_2x.jpg",
          "alt": "Matter page: tap Associate a lock."
        },
        {
          "src": "uk-manual-g6-matter-03_2x.jpg",
          "alt": "Select the device you want to connect to Matter."
        },
        {
          "src": "uk-manual-g6-matter-04_2x.jpg",
          "alt": "Tap Save to confirm the selected device."
        },
        {
          "src": "uk-manual-g6-matter-05_2x.jpg",
          "alt": "Matter page: tap Pair with a Matter App."
        },
        {
          "src": "uk-manual-g6-matter-06_2x.jpg",
          "alt": "Tap Start. The QR code shown is an example; use your own gateway’s code."
        },
        {
          "src": "uk-manual-g6-matter-07_2x.jpg",
          "alt": "The G6 has entered pairing mode. Continue in Google Home or Apple Home."
        }
      ]
    },
    {
      "handle": "g6-04",
      "title": "Delete the gateway",
      "category": "Manage your gateway",
      "steps": [
        "Open TTLock and select the gateway you want to delete.",
        "Check the gateway name so you remove the correct device, then tap “Delete”.",
        "Confirm the deletion when prompted by the app."
      ],
      "notes": [
        "Deletion is a separate task, not part of initial setup."
      ],
      "warnings": [],
      "common_mistakes": [
        "Selecting the wrong gateway — check its name before deleting it.",
        "Leaving the confirmation unfinished — confirm the deletion in the app."
      ],
      "summary": "Remove the selected G6 gateway from your TTLock account. This task is only needed when you want to delete a gateway.",
      "expected_result": "The selected gateway is removed from your TTLock device list.",
      "images": [
        {
          "src": "uk-manual-g6-delete-01_2x.jpg",
          "alt": "TTLock device list: select the G6 gateway you want to remove."
        },
        {
          "src": "uk-manual-g6-delete-02_2x.jpg",
          "alt": "Selected gateway: check its name, then tap Delete."
        },
        {
          "src": "uk-manual-g6-delete-03_2x.jpg",
          "alt": "Deletion prompt: confirm removal of the selected gateway."
        }
      ]
    }
  ],
  "troubleshooting": [
    {
      "handle": "g6-red-light",
      "title": "Flashing red — poor network connection",
      "category": "Network",
      "explanation": "The G6 light guide identifies flashing red as poor network connectivity: the gateway cannot communicate with the server.",
      "symptoms": [
        "The gateway indicator flashes red."
      ],
      "quick_checks": [
        "During setup, select a 2.4 GHz Wi-Fi network and check the password.",
        "Check your router and internet connection."
      ],
      "fix_steps": [
        "Compare your setup with “Bind the gateway to the app” below.",
        "If the light continues flashing red, contact support with the light pattern and the app screen where you are stuck."
      ],
      "related_guides": [
        "g6-01",
        "g6-02"
      ],
      "support_evidence": [
        "Light colour and flashing pattern",
        "Router model and selected Wi-Fi band",
        "App screenshot with any password hidden"
      ]
    },
    {
      "handle": "g6-wont-add",
      "title": "Gateway won’t add in TTLock",
      "category": "App setup",
      "symptoms": [
        "The G6 does not finish adding to the app."
      ],
      "quick_checks": [
        "Use TTLock and choose G6 (Matter).",
        "Wait for alternating red and blue before tapping Next.",
        "Select 2.4 GHz Wi-Fi and check the password."
      ],
      "fix_steps": [
        "Follow the illustrated binding guide and tap + next to the discovered G6.",
        "Enter the Wi-Fi details and gateway name, then tap OK.",
        "If you cannot reach the documented ready state or setup still fails, contact support."
      ],
      "related_guides": [
        "g6-02",
        "g6-01"
      ],
      "support_evidence": [
        "Screenshot of the stage where adding stops",
        "Light colour and pattern",
        "Phone model and TTLock version"
      ]
    },
    {
      "handle": "g6-matter-help",
      "title": "Need help adding Matter?",
      "category": "Matter setup",
      "explanation": "Steady blue is the G6 Matter-ready state; flashing blue indicates TTLock configuration.",
      "quick_checks": [
        "Select the lock under Associate a lock, then tap Save.",
        "Tap Pair with a Matter App, then Start.",
        "Use the Matter code on your own gateway."
      ],
      "fix_steps": [
        "Follow the Matter guide in order.",
        "If adding still fails, send support the stage and message shown in TTLock or the Home app."
      ],
      "related_guides": [
        "g6-03",
        "g6-01"
      ],
      "support_evidence": [
        "Home app name",
        "Gateway light pattern",
        "Screenshot of error; hide pairing codes and passwords"
      ]
    },
    {
      "handle": "g6-delete-help",
      "title": "Need help deleting the gateway?",
      "category": "Manage your gateway",
      "symptoms": [
        "You need to remove a G6 gateway from TTLock."
      ],
      "quick_checks": [
        "Check the name of the gateway you have selected."
      ],
      "fix_steps": [
        "Select the gateway, tap Delete, then confirm the deletion.",
        "If the app differs from the illustrated guide or deletion does not complete, contact support with the message shown."
      ],
      "related_guides": [
        "g6-04"
      ],
      "support_evidence": [
        "Screenshot of the selected gateway or error",
        "TTLock app version",
        "Whether the confirmation completed"
      ]
    }
  ],
  "videos": [],
  "support_templates": [
    {
      "title": "Gateway won’t add or flashes red",
      "subject": "G6 Wi-Fi Gateway — setup or network help",
      "body": "Hi Blusafe team,\n\nI need help with my G6 Wi-Fi Gateway.\n\nOrder number: \nPhone model: \nTTLock version: \nStep where I am stuck: \nLight colour and pattern: \nSelected network band (G6 needs 2.4 GHz): \nRouter model: \nMessage shown in TTLock: \n\nI have attached a screenshot of the relevant app screen and, if useful, a short video of the indicator. I have hidden any passwords.\n\nThanks,\n[Your name]"
    },
    {
      "title": "Help removing a gateway",
      "subject": "G6 Wi-Fi Gateway — removal help",
      "body": "Hi Blusafe team,\n\nI need help with my G6 Wi-Fi Gateway.\n\nOrder number: \nPhone model: \nTTLock version: \nGateway name: \nWhat happens after tapping Delete: \nDid the confirmation complete?: \nMessage shown in TTLock: \n\nI have attached a screenshot of the relevant app screen and, if useful, a short video of the indicator. I have hidden any passwords.\n\nThanks,\n[Your name]"
    },
    {
      "title": "Help adding Matter",
      "subject": "G6 Gateway — Matter setup help",
      "body": "Hi Blusafe team,\n\nOrder number: \nTTLock version: \nHome app (Google Home or Apple Home): \nGateway light pattern: \nLock selected under Associate a lock: \nStage where setup stops: \nError message: \n\nI have attached a screenshot with pairing codes and passwords hidden.\n\nThanks,\n[Your name]"
    }
  ],
  "support_email": "enquiries@blusafesolutions.co.uk",
  "search_index": [
    {
      "title": "Indicator light status",
      "type": "guide",
      "category": "Preparation",
      "anchor": "g6-01",
      "summary": "Understand the meaning of different LED indicator light patterns on the G6 Smart Gateway.",
      "keywords": "Connect the G6 gateway to its power supply. Observe the indicator colour and flashing pattern. Compare the pattern with the status descriptions below. Red and blue flashing alternately: ready to be added in TTLock. Blue flashing: TTLock binding is being configured. Blue stays on: Matter ready state; the gateway can be added by a Matter controller. Red flashing: poor network; the gateway cannot communicate with the server."
    },
    {
      "title": "Bind the gateway to the app",
      "type": "guide",
      "category": "App setup",
      "anchor": "g6-02",
      "summary": "Connect the G6 Smart Gateway to the TTLock APP and configure it for use with your WiFi network.",
      "keywords": "Connect the gateway to its power supply. Open the \"TTLock\" APP on your smartphone. Tap the “+” button in the upper-right corner of the TTLock home screen. Select \"G6 (Matter)\" from the device list. Verify the gateway indicator is flashing red and blue alternately, then tap \"Next\". When the G6 device appears in the search results, tap the \"+\" button next to it. Tap “WiFi Name” and select an available 2.4 GHz Wi-Fi network. Enter your WiFi password accurately. Enter a recognizable name for your Gateway (e.g., \"Living Room Gateway\"). Tap \"OK\" to complete the binding process. Wait for the gateway to automatically search for and connect to devices already bound in the APP. The G6 uses 2.4 GHz Wi-Fi only. The images show example network and device details; enter your own details."
    },
    {
      "title": "Set up Matter",
      "type": "guide",
      "category": "Matter setup",
      "anchor": "g6-03",
      "summary": "Associate a lock in TTLock, then add your G6 to Google Home or Apple Home using the gateway’s own Matter code.",
      "keywords": "Open the G6 gateway page in TTLock, then tap “Matter”. Tap “Associate a lock” and select the device you want to connect to Matter. Tap “Save”. Tap “Pair with a Matter App”, then tap “Start”. Open Google Home or Apple Home and tap “+” or “Add Accessory”. Scan the Matter QR code on the bottom of your own gateway and complete the app’s binding steps. The supplier instructions illustrate Google Home and Apple Home. QR codes and network/device details shown in the manual are examples. Use the code on your own gateway."
    },
    {
      "title": "Delete the gateway",
      "type": "guide",
      "category": "Manage your gateway",
      "anchor": "g6-04",
      "summary": "Remove the selected G6 gateway from your TTLock account. This task is only needed when you want to delete a gateway.",
      "keywords": "Open TTLock and select the gateway you want to delete. Check the gateway name so you remove the correct device, then tap “Delete”. Confirm the deletion when prompted by the app. Deletion is a separate task, not part of initial setup."
    },
    {
      "title": "Flashing red — poor network connection",
      "type": "troubleshooting",
      "category": "Network",
      "anchor": "g6-red-light",
      "summary": "The G6 light guide identifies flashing red as poor network connectivity: the gateway cannot communicate with the server.",
      "keywords": "During setup, select a 2.4 GHz Wi-Fi network and check the password. Check your router and internet connection. Compare your setup with “Bind the gateway to the app” below. If the light continues flashing red, contact support with the light pattern and the app screen where you are stuck. The gateway indicator flashes red."
    },
    {
      "title": "Gateway won’t add in TTLock",
      "type": "troubleshooting",
      "category": "App setup",
      "anchor": "g6-wont-add",
      "summary": "Gateway won’t add in TTLock",
      "keywords": "Use TTLock and choose G6 (Matter). Wait for alternating red and blue before tapping Next. Select 2.4 GHz Wi-Fi and check the password. Follow the illustrated binding guide and tap + next to the discovered G6. Enter the Wi-Fi details and gateway name, then tap OK. If you cannot reach the documented ready state or setup still fails, contact support. The G6 does not finish adding to the app."
    },
    {
      "title": "Need help adding Matter?",
      "type": "troubleshooting",
      "category": "Matter setup",
      "anchor": "g6-matter-help",
      "summary": "Steady blue is the G6 Matter-ready state; flashing blue indicates TTLock configuration.",
      "keywords": "Select the lock under Associate a lock, then tap Save. Tap Pair with a Matter App, then Start. Use the Matter code on your own gateway. Follow the Matter guide in order. If adding still fails, send support the stage and message shown in TTLock or the Home app."
    },
    {
      "title": "Need help deleting the gateway?",
      "type": "troubleshooting",
      "category": "Manage your gateway",
      "anchor": "g6-delete-help",
      "summary": "Need help deleting the gateway?",
      "keywords": "Check the name of the gateway you have selected. Select the gateway, tap Delete, then confirm the deletion. If the app differs from the illustrated guide or deletion does not complete, contact support with the message shown. You need to remove a G6 gateway from TTLock."
    }
  ]
};
